import { createFileRoute, useNavigate, useRouter, useSearch } from '@tanstack/react-router';
import AuthForm from '@/components/Auth';
import { AuthPageShell } from '@/components/Auth/AuthPageShell';
import { useAuth } from '@/lib/auth';
import Loader from '@/components/Loader';
import { useEffect } from 'react';
import { GreetLogo } from '@/components/brand/GreetLogo';
import { z } from 'zod';
import { zodValidator } from '@tanstack/zod-adapter';

const loginSearchSchema = z.object({
  returnTo: z.string().optional(),
  // Invite token, kept so Google sign-in from here still joins the invited workspace
  token: z.string().optional(),
});

export const Route = createFileRoute('/login')({
  ssr: false,
  component: LoginPage,
  validateSearch: zodValidator(loginSearchSchema),
});

function LoginPage() {
  const navigate = useNavigate();
  const { returnTo } = useSearch({ from: '/login' });
  const { isAuthenticated, isInitialLoading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    router.preloadRoute({ to: '/dashboard' }).catch(() => {});
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      if (returnTo) {
        navigate({ to: returnTo as any });
        return;
      }
      navigate({ to: '/dashboard' });
    }
  }, [isAuthenticated, returnTo, navigate]);

  if (isInitialLoading) {
    return <Loader />;
  }

  return (
    <AuthPageShell
      logo={<GreetLogo className="h-8 w-auto" />}
    >
      <AuthForm returnTo={returnTo} />
    </AuthPageShell>
  );
}
